import { LayoutNode } from '../types';

/** Mirror left-right: reverse children of every V[...] node. */
export function mirrorLR(node: LayoutNode): LayoutNode {
  if (node.kind === 'leaf') return node;
  const children = node.children.map(mirrorLR);
  if (node.kind === 'vsplit') {
    return { kind: 'vsplit', children: children.slice().reverse() };
  }
  return { kind: 'hsplit', children };
}

/** Flip top-bottom: reverse children of every H[...] node. */
export function flipTB(node: LayoutNode): LayoutNode {
  if (node.kind === 'leaf') return node;
  const children = node.children.map(flipTB);
  if (node.kind === 'hsplit') {
    return { kind: 'hsplit', children: children.slice().reverse() };
  }
  return { kind: 'vsplit', children };
}
